import { VolumeDown, VolumeOff, VolumeUp } from '@mui/icons-material';
import { Box, IconButton, Slider } from '@mui/material';
import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectPersistedPlayerVolumePreference,
  userPreferencesActions,
} from '@/store';

export const VolumeSlider = ({ iconSize = 24 }: { iconSize?: number }) => {
  const dispatch = useDispatch();
  const [sliderValue, setSliderValue] = useState<number>();
  const previousSliderValueRef = useRef<number>(undefined);
  const playerVolume = useSelector(selectPersistedPlayerVolumePreference);

  const displayVolume = sliderValue || playerVolume;
  const Icon =
    playerVolume === 0 ? VolumeOff : displayVolume < 50 ? VolumeDown : VolumeUp;

  const onSlide = (val: number) => {
    setSliderValue(val);
    previousSliderValueRef.current = sliderValue;

    if (val === playerVolume) return;
    if (Math.abs(val - playerVolume) > 10 || val === 0) {
      dispatch(userPreferencesActions.setPlaybackVolumePreference(val));
    }
  };

  const handleIconClick = () => {
    if (playerVolume > 0) {
      onSlide(0);
    } else {
      onSlide(previousSliderValueRef.current || 20);
    }
  };

  return (
    <Box sx={styles.container}>
      <IconButton
        sx={styles.volumeIconContainer}
        onClick={handleIconClick}
        aria-label={playerVolume > 0 ? 'Mute' : 'Unmute'}>
        <Icon
          sx={{
            fontSize: iconSize,
          }}
        />
      </IconButton>
      <Box sx={styles.volumeControlContainer}>
        <Slider
          orientation="horizontal"
          value={displayVolume}
          min={0}
          max={100}
          aria-label="Volume"
          onChange={(_e, value) => onSlide(value as number)}
          sx={{
            ...styles.root,
            '& .MuiSlider-thumb': styles.thumb,
            '& .MuiSlider-track': styles.track,
            '& .MuiSlider-rail': styles.rail,
          }}
        />
      </Box>
    </Box>
  );
};

const styles = {
  container: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  volumeIconContainer: {
    color: 'secondary.active',
    mr: 2,
    mt: 0.5,
  },
  volumeControlContainer: {
    width: 150,
  },
  root: {
    height: 4,
    padding: '10 0',
    verticalAlign: 'middle',
  },
  track: {
    color: 'secondary.active',
    height: 4,
  },
  rail: {
    color: 'white',
    height: 4,
  },
  thumb: {
    color: 'secondary.active',
    height: 12,
    width: 12,
  },
};
